import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=32f514d8&"
import script from "./PdfPage.vue?vue&type=script&lang=js&"
export * from "./PdfPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports